"use strict";
import axios from 'axios';

const registerVisit = () => {
    axios.post('https://t.alobienparce.com/views/v1/albp', {
        postId: window.dataLayer[0].postId,
        postDate: window.dataLayer[0].postDateTime
    })
};

export const initTrends = () => {
    if (window.dataLayer && window.dataLayer[0] && window.dataLayer[0].postId) {
        registerVisit();
    }
};